import { render } from "./ArticleContent.vue?vue&type=template&id=1d220568&scoped=true"
import script from "./ArticleContent.vue?vue&type=script&lang=js"
export * from "./ArticleContent.vue?vue&type=script&lang=js"

import "./ArticleContent.vue?vue&type=style&index=0&id=1d220568&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d220568"]])

export default __exports__